import { Injectable } from '@angular/core';

declare let gtag: (type: string, eventName: string, data: any) => void;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  // TODO - Do not needed anymore ?

  constructor() { }

  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null
  ){
    gtag('event', eventName, {
      eventCategory,
      eventLabel,
      eventAction,
      eventValue
    });
  }

}
